import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../../../assets/aw-footer-logo.jpg'


const _hoisted_1 = { class: "report-template" }
const _hoisted_2 = { class: "report-template" }
const _hoisted_3 = { class: "report-page-card temp-class" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = {
  key: 0,
  class: "my-8 px-8 sample-img-container",
  style: {"position":"relative"}
}
const _hoisted_6 = { class: "call-action-btns" }
const _hoisted_7 = { class: "footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_card, {
      class: "report-page-card top-right-color-triangle",
      outlined: "",
      flat: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "section" }, [
                _createElementVNode("div", { class: "section-title" }, [
                  _createElementVNode("div", { class: "section-badge" }),
                  _createTextVNode(" Further Services ")
                ]),
                _createElementVNode("div", { class: "section-content" }, [
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Meeting the DWP’s statutory guidance on small DC scheme consolidation"),
                  _createTextVNode(" The DWP in its consultation response on improving member outcomes makes it clear that "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createTextVNode(" “trustees may use measures such as the individual rate of return or risk adjusted returns if they consider this will help explain performance more easily in addition to the net returns disclosure the guidance sets out” "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Submission of Scheme returns"),
                  _createTextVNode(" To comply with the DWP’s guidance to small schemes conducting Value for Member Assessments, net performance comparisons will need to be completed for relevant DC schemes as part of the scheme return. "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Working with consultants"),
                  _createTextVNode(" We recognise that the majority of larger DC schemes have existing consultancy agreements and that such schemes will either complete their own VFM assessments or use their existing advisers. Our work is designed to complement rather than compete with such services, “explaining performance more easily”. "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Introducing consultants"),
                  _createTextVNode(" We also recognise that some smaller schemes do not have consultants and may require a fully compliant service. If asked to, AgeWage will offer both IRR comparisons and the net performance comparisons required to be returned to the Pensions Regulator. Where there is no consultant in place, we will make introductions. "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Resolving conflicts"),
                  _createTextVNode(" Some consultants may prefer to use AgeWage’s service where they are the founder of a consolidating master trust and wish to be a consolidating scheme. Using this independent assessment service will help trustees and consultants avoid conflicts. "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Market testing"),
                  _createTextVNode(" Where requested, we will introduce trustees to a range of consolidators, providing analysis on each. AgeWage already works with several insurers and their IGCs, with several master trusts and with participating employers in multi-employer arrangements both trust and contract based. We intend to list all types of schemes by type (contract based, bundled and unbundled single employer, master-trust). We may in time publish league tables in terms of performance, data quality and risk-adjusted performance but only with the individual consent of consolidators. "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createTextVNode(" Where further ratings are available (for instance on ESG and Quality of Service) we may introduce these in time. "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Due Diligence"),
                  _createTextVNode(" Where a consolidator wants an assessment of data quality or of the scheme demographics and the scheme to be consolidated consents, AgeWage will provide a data assessment to the consolidator (with the ceding trustee's consent) "),
                  _createElementVNode("br"),
                  _createElementVNode("br"),
                  _createElementVNode("div", { class: "bold-700" }, "Ongoing reportings"),
                  _createTextVNode(" AgeWage will provide ongoing VFM reporting to participating employers in multi-employer schemes and to the trustees of single occupational schemes. This is a separate service offered on commercial terms available on request from AgeWage. ")
                ])
              ], -1)),
              (_ctx.isBenchmarkUser)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _cache[2] || (_cache[2] = _createElementVNode("img", {
                      src: "../../../../assets/sample-report.jpg",
                      width: "100%"
                    }, null, -1)),
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_v_btn, {
                        class: "filter-btn call-action-btn elevation-6 mt-0 mx-4",
                        text: "",
                        onClick: _ctx.redirectToSampleReport
                      }, {
                        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                          _createElementVNode("span", { class: "call-btn-text" }, "View sample VFM report", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_v_btn, {
                        class: "filter-btn call-action-btn elevation-6 mt-0 mx-4",
                        text: "",
                        onClick: _ctx.getVFMReport
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("span", { class: "call-btn-text" }, "Request my VFM report", -1)
                        ]))]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1)),
          _createVNode(_component_v_img, {
            class: "footer-img",
            src: _imports_0
          })
        ])
      ]),
      _: 1
    })
  ]))
}